module.exports = __webpack_public_path__ + "img/record-button.d8eb8500.png";